import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import {
  ApiResponse,
  GetProviderTagsDetailedResponse,
  ProviderTagWithUsage,
} from '@magnetar/admin-api-interfaces'

interface UseProviderTagsManagementParams {
  providerId?: number | null
  type?: 'clinic'
}

/**
 * 工具包標籤管理頁專用：取得標籤完整資料 + 使用診所數
 */
export function useProviderTagsManagement({
  providerId,
  type = 'clinic',
}: UseProviderTagsManagementParams) {
  const { token } = useAuth()

  const url =
    token && providerId
      ? `/api/provider-tags?type=${type}&provider_id=${providerId}&detailed=1`
      : null

  const { data, error, isLoading, mutate } = useGet<
    ApiResponse<GetProviderTagsDetailedResponse>
  >(url, undefined, token ?? '')

  const items: ProviderTagWithUsage[] = data?.data?.items ?? []

  return {
    items,
    isLoading,
    isError: error,
    mutate,
  }
}
